import { Box } from '@mui/material';
import insightLogo from 'assets/insight-logo.png';

export function InsightLogo() {
  return (
    <Box
      component='img'
      sx={{ maxHeight: theme => theme.mixins.toolbar.minHeight }}
      src={insightLogo}
      alt='insight logo'
    />
  );
}
